import { getWorkflowSpecifications } from '@/defaults/workflowSpecification'

/**
 * Translated label for a status history entry. Prefers the document type's workflow title
 * (e.g. planning "done" is "Intern"), then the generic status label, then the raw name.
 */
export function statusLabel(
  status: string,
  t: (key: string) => string,
  documentType?: string
): string {
  const workflowTitle = documentType
    ? getWorkflowSpecifications()[documentType]?.[status]?.title
    : undefined

  if (workflowTitle) {
    return workflowTitle
  }

  const labels: Record<string, string> = {
    created: t('core:status.created'),
    draft: t('core:status.draft'),
    done: t('core:status.done'),
    approved: t('core:status.approved'),
    usable: t('core:status.usable'),
    withheld: t('core:status.withheld'),
    unpublished: t('core:status.unpublished'),
    needs_proofreading: t('core:status.needs_proofreading'),
    print_done: t('core:status.print_done')
  }

  return labels[status] ?? status
}
